import { useCallback, useEffect, useRef } from 'react';

// Cierra la alerta de la página pasado un tiempo. Un solo temporizador a la vez: programar uno nuevo cancela el anterior (antes el viejo
// borraba una alerta nueva antes de tiempo) y al salir de la pantalla se cancela (antes seguía vivo). Uso:
//   const cerrarAlertaEn = useCierreAlerta(setAlert);   ...   setAlert({ type, message }); cerrarAlertaEn(3500);
export default function useCierreAlerta(setAlert) {
  const temporizador = useRef(null);
  useEffect(() => () => clearTimeout(temporizador.current), []);
  return useCallback((ms) => {
    clearTimeout(temporizador.current);
    temporizador.current = setTimeout(() => setAlert(null), ms);
  }, [setAlert]);
}
